export class DataImportedReview {
  entityImportedDataList: EntityImportedData[];
  bankInstitutions: BankInstitutionVO[];
  transactionProfiles: TransactionProfileImportedData[];
}

export class BankInstitutionVO {
  bankId: number;
  bankName: string;
  bankCode: string;
  bankAddress: any;
  bankAccounts: BankAccountVO[];
  // Reference to bank institution (for tracking and re-import)
  mappedBankInstitutionId?: number; // ID of bank institution in database (whether mapped to existing or newly created)
}

export class EntityImportedData {
  person: PersonVO;
  organisation: OrganisationVO;
  isClient: boolean;
  exists: boolean;
  counterParties: EntityImportedData[];
  bankAccounts: BankAccountVO[];
  // Explicit mapping for clients
  mappedClientId?: number;
  mappedClientName?: string;
  // Explicit mapping for entities (used for counterparties)
  mappedEntityId?: number;
  mappedEntityName?: string;
  excelClientName?: string; // Name from Excel
  searchQuery?: string; // Search query for client mapping
  entitySearchQuery?: string; // Search query for entity mapping (counterparties)
  excludedFromImport?: boolean; // Whether this client should be excluded from import
  // Note: mappedClientId and mappedEntityId are reused to store final IDs (whether mapped to existing or newly created)
  // This allows tracking and re-import. For clients: mappedClientId = client ID, mappedEntityId = relation entity ID
  // For counterparties: mappedEntityId = relation entity ID
  // Note: Bank account IDs are stored in bankAccounts[].mappedBankAccountId, no need for separate array
}

export class PersonVO {
  id: number;
  entityId: number;
  callingName: string;
  lastNames: string;
  firstNames: string;
  middleNames: string;
  gender: number;
  nationality: number;
  birthday: Date;
  ssn: string;
  logo: string;
}

export class OrganisationVO {
  id: number;
  entityId: number;
  name: string;
  isin: string;
  legalValue: number;
  stockExchangeValue: number;
  incorporatedDate: Date;
  registrationCode: string;
  logo: string;
  sanctionStatus: string;
  specialFinancialInstitution: boolean;
  userId: number;
  activityCategory: any;
  activities: any[] = [];
  activitySummary: string;
  clientId: number;
  bankAccounts: BankAccountVO[] = [];
  addresses: any[] = [];
}

export class BankAccountVO {
  accountId: number;
  accountName: string;
  accountNumber: string;
  accountHolderEntityId: number;
  bankInstitutionId: number;
  bankInstitutionName: string;
  bankInstitutionCode: string;
  currencyId: number;
  currencyValue: string;
  signatureRights: string;
  // Reference to bank account (for tracking and re-import)
  mappedBankAccountId?: number; // ID of bank account in database (whether mapped to existing or newly created)
}

export class TransactionProfileImportedData {
  // Excel data - entity references (optimized: keys instead of full names)
  // These keys reference entities in entityImportedDataList: "CLIENT:name" or "ENTITY:name"
  clientEntityKey?: string; // Key to find client in entityImportedDataList (format: "CLIENT:name")
  counterPartyEntityKey?: string; // Key to find counterparty in entityImportedDataList (format: "ENTITY:name" or "CLIENT:name")
  
  // Legacy fields for backward compatibility (deprecated, use entity keys instead)
  clientName?: string;
  counterPartyName?: string;
  receiptEntries: number;
  receiptTurnover: number;
  receiptMaximum: number;
  paymentsEntries: number;
  paymentsTurnover: number;
  paymentsMaximum: number;
  currencyIsoCode: string;
  paymentNatureId: number;
  paymentNatureDescription: string;
  receiptNatureId: number;
  receiptNatureDescription: string;
  isActive: boolean;
  
  // Mapping controls
  enabled: boolean; // User can toggle this to enable/disable mapping
  
  // Generated domain objects (what will be created)
  agreement?: AgreementMapping;
  obligation?: ObligationMapping;
  rights?: RightsMapping;
  outgoingTransactionRule?: TransactionRuleMapping;
  incomingTransactionRule?: TransactionRuleMapping;
}

export class AgreementMapping {
  description: string;
  willCreate: boolean;
  // Reference to agreement (for tracking and re-import)
  mappedAgreementId?: number; // ID of agreement in database (whether mapped to existing or newly created)
}

export class ObligationMapping {
  obligationText: string;
  willCreate: boolean;
  // Reference to obligation (for tracking and re-import)
  mappedObligationId?: number; // ID of obligation in database (whether mapped to existing or newly created)
}

export class RightsMapping {
  rightsText: string;
  willCreate: boolean;
  // Reference to rights (for tracking and re-import)
  mappedRightsId?: number; // ID of rights in database (whether mapped to existing or newly created)
}

export class TransactionRuleMapping {
  name: string;
  cashFlow: string; // 'INCOMING' or 'OUTGOING'
  amountTo: number;
  frequency: number;
  frequencyPeriod: string; // 'YEAR'
  frequencyTo: number;
  willCreate: boolean;
  // Reference to transaction rule (for tracking and re-import)
  mappedTransactionRuleId?: number; // ID of transaction rule in database (whether mapped to existing or newly created)
}



// WEBPACK FOOTER //
// ./src/app/admin/import/dataImported.model.ts